import type { version_0 as ver_0, version_1 as ver_1 } from "../defs";
import { migrate as migrate_0_to_1, migrateWidget as migrate_widget_0_to_block_1 } from "./migrate_0_to_1";
import { migrate as migrate_1_to_0 } from "./migrate_1_to_0";

import { AnyVersionNewsletter, isVer0, isVer1, RawServerNewsletter } from "./types";
import { migrateAllV1 } from "./v1";

export function migrateToCurrent(input: AnyVersionNewsletter | RawServerNewsletter, currentUserId: string): ver_1.Newsletter {
  // import from our js content
  input = fromRawServer(input);

  if (isVer1(input)) {
    return v1_migrations(input);
  }

  return migrate_0_to_1(input, currentUserId);
}

export function migrateBlockToCurrent(input: ver_0.ContentWidget) {
  return migrate_widget_0_to_block_1(input);
}

// try and execute all the migrations for v_1
export function v1_migrations(input: ver_1.Newsletter): ver_1.Newsletter {
  // TODO: this is kinda lame solution at the moment, we should have a proper solution for data migrations in the future
  migrateAllV1(input);
  return input;
}

export function migrateV1toV0(input: RawServerNewsletter | ver_0.Newsletter | ver_1.Newsletter, currentUserId: string): ver_0.Newsletter {
  // import from our js content
  input = fromRawServer(input);

  if (isVer0(input)) {
    return input;
  }

  return migrate_1_to_0(input, currentUserId);
}

export function fromRawServer(input: AnyVersionNewsletter | RawServerNewsletter): AnyVersionNewsletter {
  if ("js_content" in input) {
    return {
      id: input.id,
      short: input.short,
      design: input.design,
      _v: input._v,
      content: JSON.parse(input.js_content)
    } as AnyVersionNewsletter;
  }

  return input;
}
